export class sessionData {
  studyId: number;

}
